import { getPriceFinality } from '@hero/core';
import type { CreateMultiOrderAPI } from '@hero/api';
import type { OrderContractElement } from '@hero/schema';

type OneTimePriceInput = NonNullable<
  CreateMultiOrderAPI['req']['routes'][number]['price']
>;

/**
 * Decides whether a reorder should forward `routes[i].price` so the
 * backend stamps `one_time_pricing` instead of re-resolving from the
 * Route book.
 */
export function resolveReorderOneTimePriceLock(
  sourceLeg: OrderContractElement | undefined,
): OneTimePriceInput | undefined {
  if (!sourceLeg?.amount) return undefined;

  const subtotal = sourceLeg.amount.itemsOriginalSubtotal ?? 0;
  if (subtotal <= 0) return undefined;
  if (getPriceFinality(sourceLeg) !== 'manual') return undefined;

  return {
    itemsOriginalSubtotal: subtotal,
    currency: sourceLeg.amount.currency,
    taxable: (sourceLeg.amount.tax?.applied?.length ?? 0) > 0,
  };
}
